import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a700c988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { alt: "" }
const _hoisted_2 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "seckill-goods",
    ref: "refClsDivs",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.unifiedJump($props.data)))
  }, [
    _createElementVNode("div", {
      class: "top",
      style: _normalizeStyle({ heigth: $props.width + 'px' })
    }, [
      _withDirectives(_createElementVNode("img", _hoisted_1, null, 512), [
        [_directive_lazy, _ctx.webpFilters($props.data.images)]
      ])
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString($props.data.gc_name), 1)
    ])
  ], 512))
}